import React from 'react';
import About from './About';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Accordions from '../../components/Accordions/Accordions';
import { Link } from 'react-router-dom';
export default function FAQ() {

    const accodirons = [
        {
            title: '1. A nevojitet konsultë para trajtimit?',
            content: 'Para çdo trajtimi rekomandohet një konsultë me specialistët tanë për të vlerësuar gjendjen e lëkurës ose nevojat e trupit dhe për të krijuar protokollin e duhur të trajtimit.'
        },
        {
            title: '2. Sa zgjat një trajtim?',
            content: 'Kohëzgjatja varet nga trajtimi. Kohëzgjatja e trajtimeve ndryshon në varësi të procedurës dhe zonës që trajtohet.'
        },
        {
            title: '3. A janë trajtimet e dhimbshme?',
            content: 'Shumica e trajtimeve janë jo-invazive dhe të rehatshme. Gjatë procedurës mund të ndjehet vetëm një ndjesi e lehtë nxehtësie ose stimulimi, në varësi të trajtimit.'
        },
        {
            title: '4. A ka kohë rikuperimi pas trajtimit?',
            content: 'Shumica e trajtimeve nuk kërkojnë kohë rikuperimi dhe mund të vazhdoni aktivitetet tuaja të përditshme menjëherë pas procedurës.'
        },
        {
            title: '5. Sa seanca nevojiten për rezultate?',
            content: 'Numri i seancave varet nga trajtimi dhe nga gjendja individuale e klientit. Zakonisht rekomandohet një seri prej disa seancash për rezultate optimale.'
        },
        {
            title: '6. A janë trajtimet të sigurta?',
            content: 'Po. Të gjitha trajtimet në RINU MED SPA realizohen me teknologji të avancuar dhe protokolle profesionale, duke respektuar standarde të larta sigurie dhe kujdesi.'
        },
        {
            title: '7. Si mund të rezervoj një termin?',
            content: 'Terminet mund të rezervohen duke na kontaktuar përmes telefonit, email-it ose formularit të kontaktit në website.'
        },
        {
            title: '8. Ku ndodhet RINU Med Spa?',
            content: 'RINU Med Spa ndodhet në Rr. Bekim Fehmiu, Derand Hotel (kati -1), Prishtinë.'
        },
    ]

    return (
        <About>
            <Box overflow={'hidden'}>
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container spacing={3}>
                        <Grid size={12}>
                            <Typography component={'h1'} fontWeight={'bold'} fontSize={'1.5rem'} className='dColor'>
                                FAQ
                            </Typography>
                        </Grid>
                        {/* <Grid size={12}>
                            <Typography component={'p'} fontSize={'1.125rem'} className='dColor'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                            </Typography>
                        </Grid> */}
                    </Grid>
                </Box>
                <Box sx={{ marginY: '80px', width: 1, border: 'solid 1px #DBDAD9' }} />
                <Box paddingLeft={'10%'} width={'65%'}>
                    <Grid container spacing={5}>
                        <Grid size={12}>
                            <Accordions data={accodirons} />
                        </Grid>
                    </Grid>
                </Box>
                {/* <Box paddingLeft={'10%'} width={'65%'} marginTop={'50px'}>
                    <Grid container spacing={5}>
                        <Grid size={12}>
                            <Typography component={'p'} fontSize={'1.125rem'} className='dColor'>
                                Quick Links
                            </Typography>
                        </Grid>
                        <Grid width={'95%'} marginLeft={'auto'}>
                            <Grid container>
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <Box display={'flex'} flexDirection={'column'} gap={'10px'} marginTop={'10px'} component={'ul'} padding={0}>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Skincare Products</Typography>
                                        </Box>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Daily Skincare Regime Formulas</Typography>

                                        </Box>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Cruelty-Free Serums</Typography>

                                        </Box>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Moisturisers With Spf</Typography>

                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid size={{ md: 6, xs: 12 }}>
                                    <Box display={'flex'} flexDirection={'column'} gap={'10px'} marginTop={'10px'} component={'ul'} padding={0}>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Anti-Aging Skincare Products</Typography>
                                        </Box>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Pigmentation Skincare</Typography>

                                        </Box>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>In-Clinic Treaments</Typography>

                                        </Box>
                                        <Box component={'li'}>
                                            <Typography component={Link} width={'max-content'} fontSize={'1.125rem'} color='#000' sx={{ textDecoration: 'underline' }}>Beauty Advice</Typography>

                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box> */}
            </Box>
        </About>
    )
}
